import { render, staticRenderFns } from "./ProductShare.vue?vue&type=template&id=dc1757d0&"
import script from "./ProductShare.vue?vue&type=script&lang=js&"
export * from "./ProductShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports